import { render } from "./Widget.vue?vue&type=template&id=cfb62292&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=cfb62292&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb62292"]])

export default __exports__